// pages/FormViewerPage/sections/PixelScriptsSection.tsx — Pixel + custom script injection
import React from 'react';
import type { Form } from '../../../types';
import MultiPlatformPixelScript from '../../../components/MultiPlatformPixelScript';
import CustomScriptInjector from '../../../components/CustomScriptInjector';
import { resolveEmbedTrackingMode } from '../../../utils/embedTracking';
import { getPersistentExternalId } from '../../../services/attributionIds';

export const PixelScriptsSection: React.FC<{ form: Form; formPagePixelConfigs: any[]; subtotal: number }> = ({ form, formPagePixelConfigs, subtotal }) => (
    <>
        <MultiPlatformPixelScript key={'fp-pixel-' + form.id + '-' + formPagePixelConfigs.map(c => c.pixelIds.join('-')).join('_')}
            configs={formPagePixelConfigs} pageType="formPage" contentName={form.title} contentIds={[form.slug]} value={subtotal} embedMode={resolveEmbedTrackingMode(form.trackingSettings)}
            userData={{ country: 'id', externalId: getPersistentExternalId() }} />
        <CustomScriptInjector form={form} location="formPage" />
    </>
);
